import axios from '@/api';
import authHeader from '@/services/auth-header';

const BASE_URL =
    process.env.VUE_APP_API_URL + "favorite";


class FavoriteApi {

    getGroups() {
        return axios.get(
            `${BASE_URL}/groups`,
            {
                headers: authHeader()
            }
        );
    }


    getItems(groupId) {

        return axios.get(
            `${BASE_URL}/groups/${groupId}`,
            {
                headers: authHeader()
            }
        );
    }


    createGroup(name) {

        return axios.post(
            `${BASE_URL}/groups`,
            {
                name
            },
            {
                headers: authHeader()
            }
        );
    }


    addFavorite(groupId, files) {

        return axios.post(
            `${BASE_URL}/groups/${groupId}/items`,
            {
                files
            },
            {
                headers: authHeader()
            }
        );
    }


    deleteItem(groupId, itemId) {

        return axios.delete(
            `${BASE_URL}/groups/${groupId}/items/${itemId}`,
            {
                headers: authHeader()
            }
        );
    }
}


export default new FavoriteApi();